// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"pageHeader__CO0m1","leftBlock":"leftBlock__InciG","title":"title__w-Dvf","subtitle":"subtitle__V4ScC","rightBlock":"rightBlock__Tuga6"};